import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './forgot-password.component.scss';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { toastr } from 'react-redux-toastr';
import * as forgotPasswordActions from './forgot-password.actions';
import * as authActions from '../../auth/auth.actions';
import { formDefinition } from '@social-solutions/ssg-forms-processing';
import { defaultSsgFormStyle, formElements, SsgFormComponent, ssgFormActions } from '@social-solutions/ssg-forms';

const formComponentId = "forgot-password-form-response";
export class ForgotPasswordComponent extends Component {

  handleFormSubmit(state) {
    const { forgotPasswordActions, ssgFormActions, authActions, redirectTo, onSuccess } = this.props;
    const { logoutReset } = authActions || {};
    const { resetForm } = ssgFormActions || {};
    const email = state.value['email'];

    if(!state.validationResult.passedValidation) {
      return;
    };

    // We are resetting a password and cannot possibly be logged in at the time.
    logoutReset();

    forgotPasswordActions.requestPasswordReset(email)
      .then(() => {
        resetForm(formComponentId);
        redirectTo('/login');
        onSuccess && onSuccess();
      })
      .catch( err => {
        toastr.error(err.errorCode, err.errorMessage);
        throw(err);
      });
  }

  render() {
    const emailElement = {
      id: 'email',
      type: formDefinition.elementTypes.email,
      label: "EMAIL",
      ariaLabel: "Email",
      isRequired: true,
    };

    const saveButton = {
      id: "buttonSubmit",
      type: "submit",
      display: "RESET",
      ariaLabel: "Reset",
      buttonType: "primary",
      functionType: "submit",
      spinnerDisplay: "Saving",
      onClick: (state) => {
        this.handleFormSubmit(state);
      },
    };

    var forgotPasswordElements = [ emailElement ];

    var emailStyle = formElements.defaultElementStyles.email;
    emailStyle.group += " forgot-password-input-group";
    emailStyle.input += " forgot-password-input-tag";
    emailStyle.inputError += " forgot-password-input-tag";
    emailStyle.label = "ssg-field-label";
    var formElementStyles = formElements.defaultElementStyles;
    formElementStyles.email = emailStyle;

    var formStyle = {
      actions: defaultSsgFormStyle.actions + " forgot-password-action-bar",
      primaryButton: defaultSsgFormStyle.primaryButton + " forgot-password-form-button",
      title: defaultSsgFormStyle.title = "ssg-forms-text large forgot-password-title",
    }

    const formProps = {
      id: formComponentId,
      form: {
        id: "ssg-forgot-password-form",
        name: "Forgot Password",
        elements: forgotPasswordElements
      },
      elementStyles: formElementStyles,
      buttonLayout: [ saveButton ],
      css: formStyle,
      disableValidationResultList: true,
    };

    return (
      <div id="forgot-password-form">
        <SsgFormComponent {...formProps} />
      </div>
    );
  }
}

ForgotPasswordComponent.propTypes = {
  forgotPasswordActions: PropTypes.any.isRequired,
  authActions: PropTypes.any.isRequired,
  onSuccess: PropTypes.func,
}

const mapStateToProps = () => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    forgotPasswordActions: bindActionCreators(forgotPasswordActions, dispatch),
    authActions: bindActionCreators(authActions, dispatch),
    ssgFormActions: bindActionCreators(ssgFormActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordComponent);



// WEBPACK FOOTER //
// src/acct/password/forgot-password.component.js